export const FLAG_ID = 'bulk-operations-core.edit-form.edit-form-status-flags.submit-success-flag';
export const TEST_ID =
	'bulk-operations-core.ui.edit-form.edit-form-status-flags.operation-success-flag';
